// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6bafab82","649":"4d4ed98f","692":"757cbba1"}[chunkId] + ".chunk.js";
};